// const BASE = "http://192.168.1.164:8888"
// const BASE = "http://192.168.1.122:8890"
// const BASE = 'http://192.168.1.38:8890' // 测试环境
// const BASE = 'http://47.111.108.103' // 阿里云测试环境之前
// const BASE = 'http://47.111.108.103:8081' // 阿里云测试环境
// const BASE = 'http://121.40.206.97:8001' // 生产环境1
// const BASE = 'http://121.40.244.179:8001' // 生产环境2
// const BASE = 'https://eems.trustdo.cn' // 生产域名环境
// const BASE = '/myBase'
// const BASE = 'http://1.119.196.30:2052' // 38在家应急端口外网
// const BASE = '';
const BASE = process.env.BASE_URL;

const urls = {
  BASE,
  findContractDetail: BASE,
  login: BASE + "/login/login", // 登录
  loginIndex: BASE + "/login/index", // 首页
  logout: BASE + "/login/logout", // 退出登录
  // 统计块
  getCensusBusiness: BASE + "/census/selectBusinessCensus", // 业务统计初始化信息
  setCensusBusiness: BASE + "/census/searchBusinessCensus", // 业务统计查询信息
  getCensusUser: BASE + "/census/selectOrgUserCensus", // 用户统计初始化信息
  setCensusUser: BASE + "/census/searchOrgUserCensus", // 用户统计查询信息
  businessStatistics: BASE + "/manage/businessStatistics",
  // 管理-账户管理
  freezeOrgAccount: BASE + "/manage/freezeOrgAccount", // 云端-企业账户冻结|解冻
  getOrgUserList: BASE + "/manage/selectOrgUserList", // 企业账户查询
  addOrgUser: BASE + "/manage/addOrgUser", // 企业账户添加
  // 机构列表信息
  getCompanyList: BASE + "/manage/selectAllOrgInfoList",
  getFatherOrgList: BASE + "/manage/selectFatherOrgList", // 企业账户添加，获取所属上级列表
  invalidOrgAccount: BASE + "/manage/invalidOrgAccount", // 云端-企业账户删除|恢复
  getTradeInfoList: BASE + "/manage/selecTradeInfoList", // 企业所属行业一览取得
  getOrgUserDetail: BASE + "/manage/selectOrgUserDetail", // 企业账户详情
  resetPassword: BASE + "/manage/resetPassword", // 云端-企业账户密码重置
  importApplyInfo: BASE + "/manage/importApplyInfo", // 应用信息导入
  // 详情-机构关联数模列表
  selectOrgApplyList: BASE + "/manage/selectOrgApplyList",
  // 云端-导出机构信息
  exportOrgInfo: BASE + "/manage/exportOrgInfo",
  // 云端-同步机构信息
  synchroOrgInfo: BASE + "/manage/synchroOrgInfo",
  updateOrgUserDetail: BASE + "/manage/updateOrgUserDetail", // 云端-企业账户基本信息更新
  // 管理-数据目录
  // 列表
  selectDataDirInit: BASE + "/manage/selectDataDirInit",
  // 列表查询
  selectDataDirInfoList: BASE + "/manage/selectDataDirInfoList",
  // 管理-数据交换
  // 列表
  selectExchangeInfoList: BASE + "/exchange/selectExchangeInfoList",
  // 详情
  selectExchangeInfoDetail: BASE + "/exchange/selectExchangeInfoDetail",
  // 管理-证书列表
  // 列表
  selectCertificateInfoList: BASE + "/certificate/selectCertificateInfoList",
  // 更新证书
  updateCertificate: BASE + "/certificate/updateCertificate",
  // 管理-应用管理块
  getApplyDetail: BASE + "/manage/selectApplyDetail", // 应用详情查询
  // 数模富文本编辑
  updateApplyDetail: BASE + "/manage/updateApplyDetail",
  exportArrangeFile: BASE + "/manage/exportArrangeFile", // 部署文件导出
  getApplyList: BASE + "/manage/selectApplyList", // 应用列表查询
  getDictionaryList: BASE + "/manage/selectDictionaryList", // 数据字典列表查询
  deleteDictionary: BASE + "/manage/deleteDictionary", // 数据字典删除
  insertOrUpdateDictionary: BASE + "/manage/insertOrUpdateDictionary", // 字典管理新增修改
  updateDictionary: BASE + "/manage/updateDictionary", // 保存数据字典
  addApplyInfo: BASE + "/manage/addApplyInfo", // 应用信息添加
  getAddApplyInfo: BASE + "/manage/selectInitApplyInfo", // 添加应用初始化

  // 查询当前组织下应用列表
  pianapplist: BASE + "/manage/selectAppList",
  // 管理--费用管理
  getBuyList: BASE + "/recharge/selectBuyList", // 费用信息列表查询
  sendBuyWarning: BASE + "/recharge/sendBuyWarning", // 云端-发送充值提醒
  getBuyDetail: BASE + "/recharge/selectBuyDetail", // 云端-费用管理详情
  getBuyHistoryList: BASE + "/recharge/selectBuyHistoryList", // 云端-购买记录查询
  buyService: BASE + "/recharge/buyService", // 云端-充值
  updateBuyWarning: BASE + "/recharge/updateBuyWarning", // 云端-服务到期提醒信息更新
  // 管理--存证管理
  // 同上 getCompanyList getOrgListForInputEv:BASE + '/manage/selectOrgListForInputEv', // 云端-存证信息企业列表查询
  getInputEvList: BASE + "/manage/selectInputEvList", // 云端-存证信息列表查询
  exportInputEvList: BASE + "/manage/exportInputEvList", // 云端-存证信息列表导出
  getInputEvDetail: BASE + "/manage/selectInputEvDetail", // 云端-存证信息详情查询
  // 设置--角色管理
  getManagerUserList: BASE + "/setting/selectManagerUserList", // 系统用户列表查询
  addManagerUserInfo: BASE + "/setting/addManagerUserInfo", // 系统用户添加
  freezeManageUser: BASE + "/setting/freezeManageUser", // 系统用户停用|复用
  invalidManageUser: BASE + "/setting/invalidManageUser", // 系统用户删除|恢复
  getManagerUserDetail: BASE + "/setting/selectManagerUserDetail", // 系统用户详情查询
  updateManageUserDetail: BASE + "/setting/updateManageUserDetail", // 系统用户详情更新
  // 设置--权限管理
  getRoleList: BASE + "/setting/selectRoleList", // 角色一览查询
  getRoleAuthorityList: BASE + "/setting/selectRoleAuthorityList", // 云端-角色分配权限列表查询
  addRole: BASE + "/setting/addRole", // 云端-角色添加
  setRoleAuthority: BASE + "/setting/setRoleAuthority", // 云端-权限修改
  // 设置--消息中心
  getNoticeList: BASE + "/setting/selectNoticeList", // 云端-消息列表查询
  sendNotice: BASE + "/setting/sendNotice", // 云端-消息发送
  // 出证列表
  selectOutputEvList: BASE + "/manage/selectOutputEvList",
  // 同步至前置机
  // synchroApplyInfo: BASE + '/manage/synchroApplyInfo',
  synchroClassInfo: BASE + "/manage/synchroClassInfo",

  // 数据交换详情获取文件信息
  selectExchangeInfoFileDetail: BASE + "/exchange/selectExchangeInfoFileDetail",
  // 数模商城
  // 数模商城列表
  getDataModelList: BASE + "/emall/listDataModel",
  // 发布
  publishApply: BASE + "/emall/publishApply",
  //数模发布
  publishApplyToEmall: BASE + "/emall/publishApplyToEmall",
  // 获取数模具体信息
  getDataModelDetail: BASE + "/emall/showEmallApplyDetail",
  // 更新状态
  updateAuthority: BASE + "/emall/updateAuthority",
  // 企业类型管理
  getCompanyTypeList: BASE + "/orgType/obtainOrgTypes",
  // 新增或是修改企业类型
  addOrEditCompanyType: BASE + "/orgType/addOrUpdateOrgType",
  // 删除企业类型
  delOrgType: BASE + "/orgType/delOrgType",
  // 查询企业类型详情
  obtainOrgTypeById: BASE + "/orgType/obtainOrgTypeById",
  // 查询关联企业类型全部数据
  obtainOrgTypeNamesList: BASE + "/orgType/obtainOrgTypeNames",
  // 获取分类列表数据
  getClassList: BASE + "/dictionary/obtainDictionaryKindNames",
  // 添加分类
  addClassItem: BASE + "/dictionary/createDictionaryKind",
  // 根据关键字查询字典信息
  obtainDictionariesByKeyword: BASE + "/dictionary/obtainDictionariesByKeyword",
  // 在线升级 应用管理
  // 列表查询
  getRetrieveList: BASE + "/app/retrieve",
  // 列表数据搜索
  findRetrieve: BASE + "/app/find",
  // 地址检测
  urlMonitor: BASE + "/app/monitor",
  // 更新
  updateRetrieve: BASE + "/app/update",
  // 上线
  online: BASE + "/app/online",
  // 下线
  offline: BASE + "/app/offline",
  // 创建应用
  createRetrieve: BASE + "/app/create",
  // 删除应用
  deleteRetrieve: BASE + "/app/delete",
  // 在线升级 程序包管理
  // 列表查询
  getPackageList: BASE + "/pack/retrieve",
  // 创建程序包
  createPackage: BASE + "/pack/create",
  // 更新程序包
  updatePackage: BASE + "/pack/update",
  // 删除程序包
  deletePackage: BASE + "/pack/delete",
  // 推送至前置机
  pushPackage: BASE + "/pack/push",
  // 查询单条程序包
  findPackage: BASE + "/pack/find",
  // 推送记录列表
  pushRetrieveList: BASE + "/pack/push/retrieve",
  // 升级记录列表
  upgradeRetrieveList: BASE + "/pack/upgrade/retrieve",
  // 创建程序包版本
  createPackageVersion: BASE + "/pack/version/create",
  // 删除程序包版本
  deletePackageVersion: BASE + "/pack/version/delete",
  // 查询机构列表
  queryOrganization: BASE + "/manage/queryOrganization",
  // 调用日志列表
  callLogList: BASE + "/saasLog/callLogList",
  // 申诉列表
  saasAppealList: BASE + "/saasLog/saasAppealList",
  // 申诉获取详情
  saasGetAppealInfoByLogId: BASE + "/saasLog/saasGetAppealInfoByLogId",
  // 申诉审批
  examineAppealLog: BASE + "/saasLog/examineAppealLog",
  // 调用日志详情页
  callLogDetail: BASE + "/saasLog/logInfo",
  // 调用日志文件下载
  callLogFileDownload: BASE + "/saasLog/logInfo/download",
  // 获取申诉详情
  saasGetAppealInfo: BASE + "/saasLog/saasGetAppealInfo",
  // 云端接口列表
  getCloudApiList: BASE + "/saasApi/getApiList",
  // 云端接口详情页
  getCloudApiInfo: BASE + "/saasApi/getApiInfo",
  // 云端接口审批
  examineCloudApi: BASE + "/saasApi/examineApi",
  // 调用统计
  getCallStatisticsChartData: BASE + "/tableData/getChartData",
  // api存活情况
  querySurvival: BASE + "/tableData/querySurvival",
  // 大屏平台信息
  platformData: BASE + "/big/platformDataRedis",
  // 企业top10
  top10Org: BASE + "/big/top10OrgRedis",
  // 实时日志
  callAllLogList: BASE + "/big/callAllLogListRedis",
  // 近1月调用量
  getChartDataRedis: BASE + "/big/getChartDataRedis",
  // 区块链统计
  queryStatByMonth: BASE + "/tableData/queryStatByMonth",
  // 恭喜数据
  queryTopApiAndModel: BASE + "/big/queryTopApiAndModelRedis",
  //存证checkData
  LogCheckData: BASE + '/saasLog/checkData',

  //TCP中心列表查询
  searchProxyInfoPage: BASE + "/saasApi/searchProxyInfoPage",
  //MQTt中心列表查询
  searchMqttInfoPage: BASE + "/saasApi/searchMqttInfoPage"
};

export default urls;



// WEBPACK FOOTER //
// ./src/api/URL.js